﻿
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { isDevMode } from '@angular/core';
import { LogService} from 'app/_services/logmanager.service';
import { Router } from '@angular/router';
import { AppConfig } from '../app.config';
import { AlertService } from './alert.service';
import { GlobalsService } from 'app/_services/globals.service';
import { LoginControl } from './logincontrol.service';

import { map, catchError } from 'rxjs/operators';

@Injectable()
export class DataService {

    usedparams: any;

    static getErrorInfo(actionerror: string) {
        let mensaje = '';
        switch (actionerror) {
            case 'WsAltaAlumne':
                mensaje = 'Ha fallat la comunicació amb el servidor i no s\'ha pogut donar d\'alta l\'usuari.';
                break;
            default:
                // acció per defecte
                mensaje = 'Ha fallat l\'acció ' + actionerror + ' en la resposta del servidor.';
        }
        return mensaje;

    }

    constructor(
        private http: HttpClient,
        private config: AppConfig,
        private alertService: AlertService,
        private router: Router,
        private loginControl: LoginControl,
        private globalStorage: GlobalsService
    ) { }

    getData(params: any, debug = false): Observable<any> {
        let ruta = this.config.apiUrl + this.config.wsapi;

        debug = debug || isDevMode();

        if (!debug) {
            this.alertService.clear();
        }

        if (params.hasOwnProperty('message')) {
            this.alertService.loading(params.message);
        } else {
            this.alertService.loading('Espereu... ');
        }

        LogService.log('DataManagerService', '****** getData', debug);
        LogService.log('DataManagerService', '****** getData -> ruta: ' + ruta, debug);
        LogService.log('DataManagerService', '****** getData -> params', debug);
        LogService.log('DataManagerService', params, debug);

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        // Add token
        const jsonuser = this.globalStorage.getItem('currentUser');
        LogService.log('DataManagerService', '****** getData -> jsonuser', debug);
        LogService.log('DataManagerService', jsonuser, debug);

        const currentUserJ = this.globalStorage.getItem('currentUser');
        if (currentUserJ) {
            const currentUser = JSON.parse(currentUserJ);
            if (currentUser) {
                params['token'] = currentUser.token;
            }
        }

        // Add secretaria
        const secretariaId = this.globalStorage.getItem('secretaria');
        if (secretariaId) {
            params['secretaria_id'] = secretariaId;
        }

        this.usedparams = params;

        const body = JSON.stringify(params);
        LogService.log('DataManagerService', 'JSON', debug);
        LogService.log('DataManagerService', body, debug);

        return this.http.post<any>(ruta, body, { headers: headers })
            .pipe(map((resultado) => {
            LogService.log('DataManagerService', '****** getData -> returned', debug);
            LogService.log('DataManagerService', '****** getData -> resultado', debug);
            LogService.log('DataManagerService', resultado, debug);

            if (resultado) {
                this.alertService.clearLoading();

                // Update login info

                const lastUpdate = parseInt(this.globalStorage.getItem('searchUserlastUpdate'), 10);
                const now = new Date().getTime();

                // Eliminem info obsoleta quan han passat cinc minuts
                if (lastUpdate + (5 * 60 * 1000) < now && this.globalStorage.getItem('searchUserInfo') !== '') {
                    this.globalStorage.removeItem('searchUserInfo');
                }

                if (resultado.status !== '100') {
                    // If not OK
                    LogService.log('DataManagerService', '****** getData -> status KO, error ' + resultado.error, debug);

                    if (resultado.status === '401') {
                        this.router.navigate(['/login']);
                    }
                    this.alertService.error(resultado.error);
                    LogService.log('DataManagerService', '****** getData -> status KO, error ' + resultado.error, debug);

                    return observableThrowError(resultado.error);
                } else {
                    // If OK
                    if (this.globalStorage.getItem('campusdir') === '') {
                        this.globalStorage.setItem('campusdir', resultado.login.campusdir);
                        LogService.log('DataManagerService', 'campusdir desat:  ' + this.globalStorage.getItem('campusdir'), debug);
                        this.loginControl.setcheckedsession(true);
                    }
                    if (this.globalStorage.getItem('imagedir') === '') {
                        this.globalStorage.setItem('imagedir', resultado.login.imagedir);
                        LogService.log('DataManagerService', 'imagedir desat:  ' + this.globalStorage.getItem('imagedir'), debug);
                        this.loginControl.setcheckedsession(true);
                    }

                    const data = resultado.data;
                    LogService.log('DataManagerService', 'DATA: ' + JSON.stringify(data), debug);
                    return resultado.data;
                }
            } else {
                this.alertService.error('Error 2');
                LogService.log('DataManagerService', '****** getData -> error', debug);

                return observableThrowError('Error 2');
            }
        }))
        .pipe(catchError((error: any) => {
            this.alertService.clearLoading();
            let message = '';
            if (typeof(error.json) !== 'undefined' && error.json().error) {
                message = error.json().error;
            } else {
                // el webservice no ha devuelto un json
                message = DataService.getErrorInfo(this.usedparams['accio']);
            }
            this.alertService.error('Data error: ' + message);
            LogService.log('DataManagerService', '****** getData -> error ' + message, debug);

            return observableThrowError(message);
        }));
     }
}
